import { CheckoutContext } from '@/context/CheckoutContext';
import { useEffect, useRef, useState } from 'react';
import { useContext } from 'react';
import { type Stripe } from '@stripe/stripe-js';
import { getStripePaymentKeyBySelectedPaymentMethod } from '@/utils/stripe';
import { PaymentMethodEnum, type ExcludeOtherPaymentMethod } from '@/types/common';
import { stripeService } from '@/services/stripe';

export const useStripeInitialize = ({
  paymentMethod,
  isExpress,
}: {
  paymentMethod: PaymentMethodEnum;
  isExpress?: boolean;
}) => {
  const isStripeInitilized = useRef<boolean>(false);
  const [stripe, setStripe] = useState<Stripe | undefined>(undefined);
  const [isLoading, setIsLoading] = useState(true);
  const { paymentKeys, paymentMethodsSettings } = useContext(CheckoutContext);

  const initializeStripe = async () => {
    const paymentKey = getStripePaymentKeyBySelectedPaymentMethod(
      paymentMethodsSettings,
      paymentMethod as ExcludeOtherPaymentMethod,
      paymentKeys
    );
    if (!paymentKey) return;
    const stripeInstance = await stripeService.createStripeInstance(paymentKey);
    if (stripeInstance) {
      setStripe(stripeInstance);
      if (isExpress) {
        stripeService.initilizeStripeExpress(stripeInstance);
      } else {
        stripeService.initialize(stripeInstance);
      }
      setIsLoading(false);
    }
  };
  useEffect(() => {
    if (isStripeInitilized.current) return;
    initializeStripe();
    isStripeInitilized.current = true;
  }, [paymentKeys, paymentMethodsSettings]);

  return { stripe, isLoading };
};
